import { io } from "socket.io-client";
import { HOST } from "./constants";

const URL = HOST || "http://localhost:1107";
// const URL = "http://localhost:3031";

export const socket = io(URL);